module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    class: {
      "fullscreen": _vm.fullscreen
    },
    attrs: {
      "flat": ""
    }
  }, [_c('appointment-picker', {
    attrs: {
      "group-by-name": "",
      "multiple": "",
      "with-fullscreen": "",
      "dark": "",
      "dense": "",
      "with-quick-pick": false,
      "fullscreen": _vm.fullscreen,
      "compact": false
    },
    on: {
      "update:fullscreen": function($event) {
        _vm.fullscreen = $event
      }
    },
    model: {
      value: (_vm.appointments),
      callback: function($$v) {
        _vm.appointments = $$v
      },
      expression: "appointments"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-263534c4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Appointments.vue
// module id = 1363
// module chunks = 9